import { useFormik } from "formik";
import { observer } from "mobx-react-lite";
import React, { useCallback, useEffect, useState } from "react";
import { RouteComponentProps } from "react-router";
import { useMst } from "@store/Route";
import ButtonLoader from "@components/ButtonLoader/ButtonLoader";
import * as Yup from "yup";
import { windowLocationOrigin } from "@utils/validation";
import TextInputV2 from "@components/textInput/TextInputV2";
import { IoIosEyeOff, IoIosEye } from "react-icons/io";

const Login = observer((props: RouteComponentProps) => {
  const { landing, afterCreate } = useMst();
  const { setToggleShowPasswordPanel, actionLogin, setInitial, status, state } =
    landing;

  const [loginAs, setLoginAs] = useState("parent");
  const [secure, setSecure] = useState(true);
  const formik = useFormik({
    initialValues: {
      password: "",
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string().required("Password is required"),
    }),
    onSubmit: (values) => {
      actionLogin(values.email, values.password, loginAs, () => {
        props.history.push("/dashboard/schedule");
      });
    },
  });

  useEffect(() => {
    afterCreate();
  }, []);

  const textUser = useCallback(() => {
    if (loginAs === "parent") {
      return "parent";
    }
    if (loginAs === "pic") {
      return "Personal In Charge";
    }
    if (loginAs === "company") {
      return "Company";
    }
  }, [loginAs]);

  return (
    <form
      onSubmit={(e) => {
        formik.handleSubmit();
        e.preventDefault();
      }}
    >
      <h1 className="actions__header">
        Already signed up?
        <br />
        {`Log in here as a ${textUser()}`}
      </h1>

      <TextInputV2
        title="Email Address"
        type="email"
        {...formik.getFieldProps("email")}
        required
        error={formik.errors.email}
        touched={formik.touched.email}
      ></TextInputV2>
      <div className="mt-6"></div>
      <TextInputV2
        title="Password"
        type={secure ? "password" : "text"}
        id="password"
        {...formik.getFieldProps("password")}
        required
        minLength={6}
        icon={
          <div className="cursor-pointer" onClick={() => setSecure(!secure)}>
            {secure ? <IoIosEyeOff></IoIosEyeOff> : <IoIosEye></IoIosEye>}
          </div>
        }
        error={formik.errors.password}
        touched={formik.touched.password}
      ></TextInputV2>

      <ButtonLoader
        type="submit"
        className="w-full mt-6"
        isLoading={state === "pending"}
      >
        Log in
      </ButtonLoader>
      {loginAs === "parent" ? (
        <p
          className="text-xl mt-3 text-bahama_blue_hover font-semibold cursor-pointer text-center"
          onClick={() => {
            setLoginAs("parent");
            setToggleShowPasswordPanel(true);
          }}
        >
          Forget Password
        </p>
      ) : null}
      <p className="privacy-policy">
        By clicking login button, you are agree with our
        <span
          onClick={() =>
            window.open(`${windowLocationOrigin()}/privacy-policy`, "_blank")
          }
          style={{
            textDecoration: "underline",
            verticalAlign: "middle",
            paddingLeft: "5px",
            cursor: "pointer",
          }}
        >
          Privacy Policy
        </span>
      </p>
    </form>
  );
});

export default Login;
